import MyPage from '../module/MyPage.js';
import Util from '../common/Util.js';

import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";

export default class Works extends MyPage {

	constructor() {
		super();

		this.observer = null;
		this.remote = null;
		this.calendar = null;

		this.onResize = this.onResize.bind(this);
	}

	/*
	** init
	*/

	init() {
		super.init();

		this.initRemote();
		this.initObserver();
		this.initResize();

		this.initDatepicker();
		this.initAnchors();
	}

	/*
	** enter
	*/

	enter() {

		super.enter();

		this.goToMonth();

	}

	/*
	** go to 
	*/

	goToMonth() {

		const monthNow = this.DOM.section.dataset.monthNow;

		if (monthNow)
		{
			Util.scrollToElement('#' + monthNow, 1.2);
		}

	}

	/*
	** remote
	*/

	initRemote() {

		this.remote = this.DOM.section.querySelector('.page__remote');

		if (!this.remote) return;

		this.updateRemoteHeight();

	}

	updateRemoteHeight() {

		if (!this.remote) return;

		const h = this.remote.offsetHeight;
		this.remote.style.setProperty('--remote-height', `${h}px`);

	}

	/*
	** observer
	*/

	initObserver() {

		if (!this.remote) return;

		this.observer = new IntersectionObserver(([entry]) =>
		{
			this.remote.classList.toggle('is-fixed', !entry.isIntersecting);
		},
		{
			threshold: 0
		});

		this.observer.observe(this.remote);

	}

	/*
	** resize
	*/

	initResize() {

		window.addEventListener('resize', this.onResize);

	}

	onResize() {

		this.updateRemoteHeight();

	}

	/*
	** datepicker
	*/

	initDatepicker() {

		this.dateInput = this.DOM.section.querySelector('.date-input');

		if (!this.dateInput) return;

		this.calendar = flatpickr(this.dateInput, {
			dateFormat: "Y-m-d",
			onChange: (selectedDates, dateStr) => {
				this.redirectWithDate(dateStr);
			}
		});

		this.initDatepickerTrigger();

	}

	redirectWithDate (dateStr) {

		if (!this.datepickerBaseUrl) return;

			const base = this.datepickerBaseUrl.replace(/\/$/, '');

			const url = `${base}/${dateStr}`;

			window.location.href = url;

	}

	initDatepickerTrigger() {

		const btn = this.DOM.section.querySelector('.switch__anchor.datepicker');

		if (!btn) return;

		this.datepickerBaseUrl = btn.getAttribute('href');

		btn.addEventListener('click', (e) =>
		{
			e.preventDefault();
			e.stopPropagation();

			if (!this.calendar) return;

			this.calendar.open();
		});

	}

	/*
	** anchors
	*/

	initAnchors() {

		this.DOM.section.querySelectorAll('.values__anchor').forEach((item) =>
		{
			const href = item.getAttribute('href');

			if (!href) return;

			item.addEventListener('click', (event) =>
			{
				event.preventDefault();
				Util.scrollToElement(href, 1.2);
			});
		});

	}

	/*
	** unload
	*/

	unload() {

		if (this.observer) {
			this.observer.disconnect();
			this.observer = null;
		}

		window.removeEventListener('resize', this.onResize);

		this.remote = null;
		this.calendar = null;

		super.unload();

	}
}